module.exports = __webpack_public_path__ + "static/Hashicorp-f4ea633d0bc65f1798147ab97e6c5cce.jpg";